import React, { useEffect, useState } from "react";
import { ThreeCircles } from 'react-loader-spinner';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';

const TOP_KPIS_FIRST_PAGE = {
  totalvehiclecount: 0,
  fault_active_duration: 0,
  vehicle_with_fault: 0,
  vehicle_with_alarm: 0,
  vehicle_with_dtc: 0,
  faulty: 0,
  faultyslow: 0,
  faultyfast: 0,
  opportunitycharged: 0,
  opportunityslow: 0,
  opportunityfast: 0,
  fullcharged: 0,
  fullchargedslow: 0,
  fullchargedfast: 0,
  totalcharged: 0,
  totalslow: 0,
  totalfast: 0,
  slow: 0,
  fast: 0,
  both: 0,
  fault_occ_slow : 0,
  fault_occ_fast : 0,
  fault_occ : 0
};

export default function ChargingFirstPageKpis_Jupiter({ gloablfilter }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const [faultactive, setFaultActive] = useState(TOP_KPIS_FIRST_PAGE);
  const [totalvehicle, setTotalVehicle] = useState(TOP_KPIS_FIRST_PAGE);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        totalvehiclecount: temp_result[0].total_vehicle_count.value
      }
      setTopData((prestate) => responce);
    }
  }

  const faultActive = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        fault_active_duration: temp_result.hits.total.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        faulty: temp_result.aggregations.groupby.buckets[0].Faulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        faultyslow: temp_result.aggregations.groupby.buckets[0].slowFaulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        faultyfast: temp_result.aggregations.groupby.buckets[0].fastFaulty.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        opportunitycharged: temp_result.aggregations.groupby.buckets[0].Opportunity.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        opportunityslow: temp_result.aggregations.groupby.buckets[0].OpportunitySlow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        opportunityfast: temp_result.aggregations.groupby.buckets[0].OpportunityFast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fullcharged: temp_result.aggregations.groupby.buckets[0].Full.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fullchargedslow: temp_result.aggregations.groupby.buckets[0].FullSlow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fullchargedfast: temp_result.aggregations.groupby.buckets[0].FullFast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        totalcharged: temp_result.aggregations.groupby.buckets[0].doc_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        totalslow: temp_result.aggregations.groupby.buckets[0].slow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        totalfast: temp_result.aggregations.groupby.buckets[0].fast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fault_occ: temp_result.aggregations.groupby.buckets[0].Fault_occ.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fault_occ_fast: temp_result.aggregations.groupby.buckets[0].Fault_occ_fast.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        fault_occ_slow: temp_result.aggregations.groupby.buckets[0].Fault_occ_slow.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      }
      setFaultActive((prestate) => responce);
    }
  }

  const vehicleActive = (data) => {
    // setTotalVehicle([]);
    const res_result = data;
    let slow = 0, fast = 0, both = 0;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;

      data.forEach((obj1, index) => {
        if (obj1.key.uniqueChargeType == "Both")
          both = obj1.total_vehicle_count.value
        if (obj1.key.uniqueChargeType == "Slow")
          slow = obj1.total_vehicle_count.value
        if (obj1.key.uniqueChargeType == "Fast")
          fast = obj1.total_vehicle_count.value

        responce = { both: both, slow: slow, fast: fast }
        setTotalVehicle((prestate) => responce);
      })
    }else{
      responce = { both: 0, slow: 0, fast: 0 }
      setTotalVehicle((prestate) => responce);
    }
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/topkpisfirstpage", body: { filterdata: gloablfilter } }, appyData)
    fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/totalchargedcycle", body: { filterdata: gloablfilter } }, faultActive)
    fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/totalvehiclecount", body: { filterdata: gloablfilter } }, vehicleActive)
  }, [gloablfilter])


  return (
    <>
      <section className="kpi my-3">
        <div className="row">
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{totalvehicle.slow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{totalvehicle.fast}</strong> Fast |</span>
                <span className="kpiNotificationBoth"><strong>{totalvehicle.both}</strong> Both</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/EV-Logo 1.png" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{topdata.totalvehiclecount}</p>
                  <p className="m-0"><small className="text-muted">Total vehicle count</small></p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.totalslow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.totalfast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/charging 1.png" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.totalcharged}</p>
                  <p className="m-0"><small className="text-muted">Total charged cycles</small></p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.fault_occ_slow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.fault_occ_fast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/fault_kpi.svg" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.fault_occ}</p>
                  <p className="m-0"><small className="text-muted">Critical Faulty cycles</small></p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.faultyslow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.faultyfast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/charging-station 1 (1).png" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.faulty}</p>
                  <p className="m-0"><small className="text-muted">Interruption cycles</small></p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-6 col-lg-2 mb-3">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.opportunityslow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.opportunityfast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/electric 1 (1).png" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.opportunitycharged}</p>
                  <p className="m-0"><small className="text-muted">Opportunity charged cycles</small></p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-2">
            <div className="chargingWidget p-2">
              <div className="d-flex justify-content-end pe-2">
                <span className="kpiNotificationSlow me-1"><strong>{faultactive.fullchargedslow}</strong> Slow | </span>
                <span className="kpiNotificationFast"><strong>{faultactive.fullchargedfast}</strong> Fast</span>
              </div>
              <div className="p-2 d-flex align-items-center">
                <div className="chargingWidgetIcon"><img src="/assets/img/electric-car 1.png" /> </div>
                <div className="ps-3">
                  <p className="h5 m-0">{faultactive.fullcharged}</p>
                  <p className="m-0"><small className="text-muted">Full charged cycles</small></p>
                </div>
              </div>
            </div>
          </div>

        </div>
        {/* <p>Note: Component counts may differ from the total due to unique vehicle aggregation and incomplete VIN data.</p> */}
        {/* <div className="alert alert-warning" role="alert"> <strong>Note:</strong> Component counts may not match the total count due to unique vehicle aggregation and incomplete VIN data. </div> */}
        <div className="d-inline-block py-1 px-3 mb-2" style={{ fontSize: "10px" }} role="alert" > <strong>Note:</strong> Component counts may not match the total count due to unique vehicle aggregation and incomplete VIN data. </div>
      </section>
    </>
  )
}
